import { Domains } from '../../constants';
import { Hasher } from '../hasher';
import { Role } from '../types';
import { PermissionService } from './service';
import { AssignedPermissions, Permission } from './types';

export const useExecutorRoleAllPermissionsQuery = (
  debugString: string,
  permissionService: PermissionService,
  domain: Domains,
  executorRole: Role
) => {
  const key = [
    `get-executor-role-permissions domain=${domain}, executorRole=${executorRole.id}`,
    Hasher.hash(executorRole),
    ...permissionService.getDeps(),
  ];
  return {
    queryKey: key,
    queryFn: async (): Promise<AssignedPermissions<Permission>> => {
      console.debug(`[useQuery] ${debugString}`, key);
      return permissionService.listAllPermissions(executorRole.id, domain);
    },
  };
};
